var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{attrs:{"color":"primary","dark":"","height":"35"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"text-subtitle-1"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }